import { render } from "./ProfileResubscription.vue?vue&type=template&id=e8e1b0c6&ts=true"
import script from "./ProfileResubscription.vue?vue&type=script&lang=ts"
export * from "./ProfileResubscription.vue?vue&type=script&lang=ts"

import "./ProfileResubscription.vue?vue&type=style&index=0&id=e8e1b0c6&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__